import React, { useEffect, useState } from "react";
import TermsDetails from "../components/termscondition/TermsDetails";
import { useLoader } from "../context/LoaderContext";
import { IHeaderFooterData, ITermsConditionsData } from "../exports/interfaces";
import { dynamicFailed } from "../hooks/useToast";
import {
  fetchHeaderFooter,
  fetchTermsConditions,
} from "../api/TermsConditionApi";

const TermsConditions = () => {
  const { setLoading } = useLoader();
  const [headerFooterData, setHeaderFooterData] = useState<IHeaderFooterData[]>(
    []
  );
  const [termsConditionsData, setTermsConditionsData] = useState<
    ITermsConditionsData[]
  >([]);
  useEffect(() => {
    Promise.all([fetchHeaderFooter(), fetchTermsConditions()])
      .then(([headerFooterData, termsConditionsData]) => {
        setHeaderFooterData(headerFooterData);
        setTermsConditionsData(termsConditionsData);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        dynamicFailed(error.response.data.error.message);
      });
  }, [setLoading]);
  return (
    <body
      data-rsssl="1"
      className="home page-template-default page page-id-662 tg_menu_transparent tg_lightbox_black centeralign2 loftloader-lite-enabled elementor-default elementor-kit-2567 elementor-page elementor-page-662"
    >
      <TermsDetails
        headerFooterData={headerFooterData}
        termsConditionsData={termsConditionsData}
      />
    </body>
  );
};

export default TermsConditions;
